import { useTranslation } from 'react-i18next'

import ScenarioSection from '../ScenarioSection/ScenarioSection'
import ScenarioShipmentCard from './ScenarioShipmentCard/ScenarioShipmentCard'

const ShipmentsScenario = ({ scenarioShipments }) => {
  const { t } = useTranslation()

  return (
    <ScenarioSection
      title={t('Envíos')}
      emptyDescription={t('Añade envíos al pedido para ver el bloque en el layout.')}
      addLabel={t('Añadir envío')}
      isEmpty={scenarioShipments.entries.length === 0}
      onAdd={scenarioShipments.add}
    >
      {scenarioShipments.entries.map((shipment, index) => (
        <ScenarioShipmentCard
          key={shipment.id}
          shipment={shipment}
          position={index + 1}
          onChange={scenarioShipments.update}
          onRemove={scenarioShipments.remove}
        />
      ))}
    </ScenarioSection>
  )
}

export default ShipmentsScenario
